'use client';

import { c as _c } from "react/compiler-runtime";
import { WebAPIEventsPage } from '@/globals/webApiTypes/pages/WebAPIEventsPage';
import { useSelectedFilters } from '@/sections/filter/useSelectedFilters';
import { EventResults } from './EventResults';
import { filterEventResults } from './filterEventResults';
export const FilteredEventResults = t0 => {
  const $ = _c(6);
  const {
    results,
    filters
  } = t0;
  const [selectedFilters] = useSelectedFilters();
  let t1;
  if ($[0] !== filters || $[1] !== results || $[2] !== selectedFilters) {
    t1 = filterEventResults(results, selectedFilters, filters);
    $[0] = filters;
    $[1] = results;
    $[2] = selectedFilters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const filteredResults = t1;
  let t2;
  if ($[4] !== filteredResults) {
    t2 = <EventResults eventResults={filteredResults} />;
    $[4] = filteredResults;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};